import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";
import {BinCardType} from "@bounce/shared/enums";

type BinLookupResponse = {
  card_type: BinCardType | null;
};

export const binLookup = async (bin: string): Promise<BinCardType | null> => {
  const result = await axiosConsumerAppInstance.get<BinLookupResponse, AxiosResponse<BinLookupResponse>>(
    `/bin_lookup?bin=${bin}`
  );
  return result.data.card_type;
};
